import React, { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import SuccessAlert from "../helpers/successAlert";

const BreadcrumbsImageManager = ({ initialSettings, locale, t_controls }) => {
  const [breadcrumbsBgImage, setBreadcrumbsBgImage] = useState(null);
  const [breadcrumbsDarkOverlay, setBreadcrumbsDarkOverlay] = useState(!!initialSettings.breadcrumbs_dark_overlay);
  const [previewImage, setPreviewImage] = useState(initialSettings.breadcrumbs_bg_image);
  const [isLoading, setIsLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const handleSave = () => {
    const token = document.querySelector("[name=csrf-token]").content;
    const formData = new FormData();

    if (breadcrumbsBgImage) {
      formData.append("breadcrumbs_bg_image", breadcrumbsBgImage);
    }
    formData.append("breadcrumbs_dark_overlay", breadcrumbsDarkOverlay ? "true" : "false");

    setIsLoading(true);
    axios
      .patch(`/${locale}/admin/breadcrumbs_image`, formData, {
        headers: {
          "X-CSRF-TOKEN": token,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setIsLoading(false);
        setAlertMessage(t_controls.updated || "Successfully updated");
        setPreviewImage(response.data.breadcrumbs_bg_image);
        window.location.reload();
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Failed to save breadcrumbs image settings:", error);
      });
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      setPreviewImage(reader.result);
      setBreadcrumbsBgImage(file);
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className="breadcrumbs-image-form">
      {alertMessage && <SuccessAlert message={alertMessage} />}

      <h5>{t_controls.breadcrumbs_bg_image || "Section Breadcrumbs image"}</h5>
      <p className="text-muted small mb-2">
        {t_controls.breadcrumbs_bg_image_help || "Recommended image size: 1920x726 px. Keep important content near the center because the banner may crop on smaller screens."}
      </p>

      <div className="breadcrumbs-image-upload-row">
        <div className="breadcrumbs-image-main">
          <div className="breadcrumbs-image-preview">
            {previewImage ? (
              <img src={previewImage} alt="" />
            ) : (
              <p>{t_controls.no_image_text || "No image uploaded"}</p>
            )}
          </div>

          <label className="breadcrumbs-image-overlay" htmlFor="breadcrumbsDarkOverlay">
            <input
              type="checkbox"
              id="breadcrumbsDarkOverlay"
              checked={breadcrumbsDarkOverlay}
              onChange={(e) => setBreadcrumbsDarkOverlay(e.target.checked)}
            />
            <span>{t_controls.breadcrumbs_dark_overlay || "Dark Overlay"}</span>
          </label>
        </div>

        <div className="breadcrumbs-image-upload-action">
          <label htmlFor="breadcrumbs-image-input" className="btn btn-primary">
            {t_controls.upload_button || "Upload image"}
          </label>
          <input
            id="breadcrumbs-image-input"
            type="file"
            accept="image/*"
            className="d-none"
            onChange={handleImageChange}
          />
        </div>
      </div>

      <button
        className="btn btn-primary breadcrumbs-image-save"
        disabled={isLoading}
        onClick={handleSave}
      >
        {isLoading ? (t_controls.saving || "Saving...") : t_controls.save}
      </button>
    </div>
  );
};

BreadcrumbsImageManager.propTypes = {
  initialSettings: PropTypes.shape({
    breadcrumbs_bg_image: PropTypes.string,
    breadcrumbs_dark_overlay: PropTypes.bool,
  }).isRequired,
  locale: PropTypes.string.isRequired,
  t_controls: PropTypes.object.isRequired,
};

export default BreadcrumbsImageManager;
